import { render, staticRenderFns } from "./TicketListCard.vue?vue&type=template&id=4a24bae8&scoped=true&"
import script from "./TicketListCard.vue?vue&type=script&lang=js&"
export * from "./TicketListCard.vue?vue&type=script&lang=js&"
import style0 from "./TicketListCard.vue?vue&type=style&index=0&id=4a24bae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24bae8",
  null
  
)

export default component.exports